import { get } from '../api/_basic';

class ManualProcessApi {
    static async get() {
        try {
            const response = await get(process.env.REACT_APP_API_MANUAL);
            return ManualProcessApi.processFamilies(response);
        } catch (error) {
            throw error;
        }
    }

    static async processFamilies(processes) {
        try {
            console.log(processes);
            if (!processes) return undefined;
            const families = Object.keys(processes).reduce((arr, process) => {
                const proceso = processes[process];
                if (proceso && proceso.locales && proceso.locales.length > 0) {
                    proceso.codigo = process;
                    if (!arr[proceso.familia]) {
                        arr[proceso.familia] = {
                            nombre: proceso.familia,
                            procesos: [].concat([proceso]),
                        };
                    } else {
                        arr[proceso.familia].procesos.push(proceso);
                    }
                }
                return arr;
            }, {});
            return Object.keys(families).map(function(i) {
                return families[i];
            });
        } catch (error) {
            throw error;
        }
    }
}

export default ManualProcessApi;



// WEBPACK FOOTER //
// ./src/api/ManualProcessApi.js